import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import {
  Grid,
  IconButton,
  MenuItem,
  SelectChangeEvent,
  Theme,
  Tooltip,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { LabelledOutline } from '../../../common/final-form-material-ui/LabelledOutline';
import { MaterialAutocomplete } from '../../../common/formik-material-ui';
import { FormikSelect } from '../../../common/formik-material-ui/FormikSelect';
import { FormikTextField } from '../../../common/formik-material-ui/FormikTextField';

import DeleteIcon from '@mui/icons-material/Delete';
import InfoPanel from '../InfoPanel/InfoPanel';

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    height: 'max-content',
    alignSelf: 'center',
  },
  // field: {
  //   marginTop: theme.spacing(1),
  //   marginBottom: theme.spacing(1),
  // },
  // spacing: {
  //   marginTop: '2px',
  // },
  timeframes: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  deleteIconButton: {
    color: theme.custom.button.delete.main,
    height: 'max-content',
    alignSelf: 'center',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  fieldSelectCol: {
    display: 'flex',
    flexDirection: 'column',
  },
}));
export default function RuleTabActions({ formik, rules, id }) {
  const classes = useStyles();
  return (
    <div className="container">
      <InfoPanel>
        <div>
          Set conditions for your selected number(s) to follow on this tab.
          Select a Condition, then an Operator, and finally a Value. These
          Conditions and Values pull from your connected CRM to determine where
          to route inbound calls. Click the + icon to add additional conditions,
          click the trash icon to remove. All conditions on this tab apply to
          your numbers concurrently
        </div>
      </InfoPanel>
      {formik?.values?.ruleActions?.map((inboundRule, index) => {
        return (
          <div className={classes.flexRow} key={index}>
            <div
              className={classes.fieldSelectCol}
              style={{ width: '90%', paddingRight: '12.5px' }}
            >
              <LabelledOutline key={index} label={`Condition ${index + 1}`}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                    <MaterialAutocomplete
                      name={`ruleActions.${index}.rule`}
                      label="Condition"
                      variant="outlined"
                      size="small"
                      formik={formik}
                      options={rules ?? []}
                      multiple={false}
                      disableClearable
                      required
                      onChange={(
                        event: React.ChangeEvent<any>,
                        newValue: any
                      ) => {
                        formik.setFieldValue(
                          `ruleActions.${index}.type`,
                          newValue?.type ?? ''
                        );
                        formik.setFieldValue(
                          `ruleActions.${index}.operand`,
                          ''
                        );
                        formik.setFieldValue(`ruleActions.${index}.value`, '');
                      }}
                      getOptionLabel={(option) =>
                        option?.type === 'Has Owner'
                          ? 'Contact Has Owner'
                          : option?.type ?? ''
                      }
                      isOptionEqualToValue={(option, value) =>
                        !value?.type || option?.type === value?.type
                      }
                      dataPup={'rules-routing-rule-autocomplete'}
                    />
                  </Grid>
                  <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                    <div>
                      {inboundRule?.rule?.type === 'Deal Value' ||
                      inboundRule?.rule?.type === 'Last Connection Date' ||
                      inboundRule?.rule?.type === 'Last Call Date' ||
                      inboundRule?.rule?.type === 'Last SMS Date' ? (
                        <FormikSelect
                          name={`ruleActions.${index}.operand`}
                          label="Operator"
                          formik={formik}
                          size="small"
                          variant="outlined"
                          fullWidth
                          required
                          disabled={inboundRule?.rule?.type === ''}
                          dataPup={`rule-value-operator`}
                        >
                          <MenuItem
                            data-pup={`rule-value-operator-gte`}
                            value=">="
                          >
                            Greater than or equal to
                          </MenuItem>
                          <MenuItem value="<=">Less than or equal to</MenuItem>
                          {inboundRule?.rule?.type === 'Deal Value' && (
                            <MenuItem value="==">Equals</MenuItem>
                          )}
                        </FormikSelect>
                      ) : inboundRule?.rule?.type === 'Deal Status' ? (
                        <FormikSelect
                          name={`ruleActions.${index}.operand`}
                          label="Operator"
                          formik={formik}
                          size="small"
                          variant="outlined"
                          fullWidth
                          required
                          dataPup={`rule-operator-select-in-notin`}
                          disabled={inboundRule?.rule?.type === ''}
                        >
                          <MenuItem
                            data-pup={`rule-operator-select-in`}
                            value="IN"
                          >
                            IN
                          </MenuItem>
                          <MenuItem
                            data-pup={`rule-operator-select-notin`}
                            value="NOT IN"
                          >
                            NOT IN
                          </MenuItem>
                        </FormikSelect>
                      ) : inboundRule?.rule?.type === 'No Contact Data' ||
                        inboundRule?.rule?.type === 'Has Owner' ||
                        inboundRule?.rule?.type === 'Deal Has Owner' ||
                        inboundRule?.rule?.type === 'First Time Caller' ? (
                        <FormikSelect
                          name={`ruleActions.${index}.value`}
                          label="Condition Value"
                          formik={formik}
                          size="small"
                          variant="outlined"
                          fullWidth
                          required
                          dataPup={`rule-value-boolean`}
                          onChange={(event: SelectChangeEvent) =>
                            formik.setFieldValue(
                              `ruleActions.${index}.operand`,
                              event.target.value ? 'IS' : ''
                            )
                          }
                        >
                          <MenuItem
                            data-pup={`rule-value-boolean-true`}
                            value={'true'}
                          >
                            true
                          </MenuItem>
                          <MenuItem
                            data-pup={`rule-value-boolean-false`}
                            value={'false'}
                          >
                            false
                          </MenuItem>
                        </FormikSelect>
                      ) : (
                        <FormikSelect
                          name={`ruleActions.${index}.operand`}
                          label="Operator"
                          formik={formik}
                          size="small"
                          variant="outlined"
                          fullWidth
                          required
                          disabled={inboundRule?.rule?.type === ''}
                        >
                          <MenuItem value="IS">IS</MenuItem>
                        </FormikSelect>
                      )}
                    </div>
                  </Grid>
                  <Grid item xs={7} sm={7} md={5} lg={5} xl={5}>
                    {inboundRule?.rule?.type === '' && (
                      <div>
                        <FormikTextField
                          name={`ruleActions.${index}.value`}
                          type={inboundRule?.rule?.inputOptionType}
                          formik={formik}
                          label="Condition Value"
                          size="small"
                          required
                          fullWidth
                          variant="outlined"
                          disabled={inboundRule?.rule?.type === ''}
                        />
                      </div>
                    )}
                    {inboundRule?.rule?.type === 'Deal Status' && (
                      <FormikSelect
                        name={`ruleActions.${index}.value`}
                        label="Deal Status Value"
                        formik={formik}
                        size="small"
                        variant="outlined"
                        fullWidth
                        required
                        dataPup={`rule-value-deal-status`}
                        onChange={(event) => {
                          return formik.setFieldValue(
                            `ruleActions.${index}.value`,
                            event.target.value ?? ''
                          );
                        }}
                      >
                        <MenuItem
                          data-pup={`rule-value-deal-open`}
                          value={'open'}
                        >
                          open
                        </MenuItem>
                        <MenuItem
                          data-pup={`rule-value-deal-closed`}
                          value={'closed'}
                        >
                          closed
                        </MenuItem>
                        <MenuItem
                          data-pup={`rule-value-deal-all`}
                          value={'all'}
                        >
                          all
                        </MenuItem>
                      </FormikSelect>
                    )}
                    {inboundRule?.rule?.type === 'Deal Value' && (
                      <FormikTextField
                        name={`ruleActions.${index}.dealValue`}
                        // className={classes.field}
                        type={inboundRule?.rule?.inputOptionType}
                        formik={formik}
                        label="Condition Value"
                        size="small"
                        required
                        fullWidth
                        variant="outlined"
                        disabled={inboundRule?.rule?.type === ''}
                        dataPup={'rule-value-number'}
                      />
                    )}
                    {inboundRule?.rule?.inputOptionType === 'dateAgo' && (
                      <Grid container className="timeframe">
                        <LabelledOutline
                          label="Time ago"
                          customPadding="5px 8px"
                        >
                          <FormikTextField
                            formik={formik}
                            className={classes.timeframes}
                            name={`ruleActions.${index}.days`}
                            label="Days"
                            size="small"
                            InputProps={{
                              inputProps: {
                                min: 0,
                                max: 90,
                              },
                            }}
                            type="number"
                            variant="outlined"
                          />
                          <FormikTextField
                            className={classes.timeframes}
                            formik={formik}
                            name={`ruleActions.${index}.hours`}
                            label="Hours"
                            InputProps={{
                              inputProps: {
                                min: 0,
                                max: 23,
                              },
                            }}
                            size="small"
                            type="number"
                            variant="outlined"
                          />
                          <FormikTextField
                            className={classes.timeframes}
                            formik={formik}
                            name={`ruleActions.${index}.minutes`}
                            label="Minutes"
                            InputProps={{
                              inputProps: {
                                min: 0,
                                max: 59,
                              },
                            }}
                            size="small"
                            type="number"
                            variant="outlined"
                          />
                        </LabelledOutline>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </LabelledOutline>
            </div>
            <div
              style={{
                marginLeft: 'auto',
                display: 'flex',
                flexWrap: 'nowrap',
                paddingLeft: '8px',
              }}
            >
              <Tooltip title="add">
                <>
                  <IconButton
                    className={classes.icon}
                    aria-label="add"
                    color="primary"
                    onClick={() => {
                      formik.setFieldValue('ruleActions', [
                        ...formik.values.ruleActions.slice(0, index + 1),
                        {
                          value: '',
                          type: '',
                          ruleInputFrequencey: 'days',
                          rule: {
                            name: '',
                            inputOptionType: '',
                          },
                          operand: '',
                          dealValue: 0,
                          days: 0,
                          hours: 0,
                          minutes: 0,
                        } as any,
                        ...formik.values.ruleActions.slice(index + 1),
                      ]);
                    }}
                    size="large"
                  >
                    <PlaylistAddIcon />
                  </IconButton>
                </>
              </Tooltip>
              <Tooltip key={index} title="remove">
                <>
                  <IconButton
                    className={classes.deleteIconButton}
                    aria-label="cancel"
                    onClick={() => {
                      const ruleActions =
                        id !== null
                          ? [
                              ...formik.values.ruleActions.slice(0, index),
                              ...formik.values.ruleActions.slice(index + 1),
                            ]
                          : [
                              ...formik.values.ruleActions.slice(0, index),
                              ...formik.values.ruleActions.slice(index + 1),
                            ];
                      formik.setFieldValue('ruleActions', ruleActions);
                    }}
                    disabled={formik.values.ruleActions.length <= 1}
                    size="large"
                  >
                    <DeleteIcon />
                  </IconButton>
                </>
              </Tooltip>
            </div>
          </div>
        );
      })}
    </div>
  );
}
